import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class CdkMessageService {
    private _bus;
    private _uid;
    constructor(){};
    /**
     * Dispat
     * ch()
     */
    dispatch(message: any): void{};
    /**
     * message()
     */
    message(){};
}